import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPpt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1231 23H7.37685C5.51143 23 4 21.5018 4 19.6527V4.34732C4 2.49822 5.51143 1 7.37685 1H15.8423L20.5 5.63778V19.6527C20.5 21.5018 18.9886 23 17.1231 23Z",
			fill: "#F9B617"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20.5 5.63778H16.7994C16.2755 5.63778 15.8493 5.21763 15.8493 4.69822L15.8423 1",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1371 12.7965H16.4641C16.4641 15.1489 14.5102 17.0857 12.1371 17.0857C9.76398 17.0857 7.81006 15.1489 7.81006 12.7965C7.81006 10.4442 9.76398 8.50732 12.1371 8.50732V12.7965Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8311 12.1224V7.83325C13.9792 7.83325 15.0784 8.28572 15.8912 9.08908C16.7039 9.89243 17.1581 10.9844 17.1581 12.1224H12.8311Z",
			fill: "white"
		})
	]
});
export default SvgPpt;
